export default "__VITE_ASSET__8a27e30c__"